import React, { useState } from "react";
import { Trash2, FileText, FolderOpen, Bot, Shield, BrickWallShield, Users } from "lucide-react";
import Layout from "../../components/Layout";
import TrashTabs from "../../components/TrashTabs";
import DeletedPosts from "../../components/trash/DeletedPosts";
import DeletedCategories from "../../components/trash/DeletedCategories";
import DeletedBots from "../../components/trash/DeletedBots";
import DeletedTerms from "../../components/trash/DeletedTerms";
import DeletedPrivacyPolicies from "../../components/trash/DeletedPrivacyPolicies";
import DeletedUsers from "../../components/trash/DeletedUsers";
import "../../styles/member/trash.css";

interface TabItem {
  id: string;
  label: string;
  icon: React.ComponentType<any>;
  component: React.ComponentType;
}

const Trash: React.FC = () => {
  const [activeTab, setActiveTab] = useState("posts");

  const tabs: TabItem[] = [
    {
      id: "posts",
      label: "Bài viết",
      icon: FileText,
      component: DeletedPosts,
    },
    {
      id: "categories",
      label: "Danh mục",
      icon: FolderOpen,
      component: DeletedCategories,
    },
    {
      id: "bots",
      label: "Bot kiểm duyệt",
      icon: Bot,
      component: DeletedBots,
    },
    {
      id: "terms",
      label: "Điều khoản",
      icon: Shield,
      component: DeletedTerms,
    },
    {
      id: "privacy-policies",
      label: "Chính sách",
      icon: BrickWallShield,
      component: DeletedPrivacyPolicies,
    },
    {
      id: "users",
      label: "Người dùng",
      icon: Users,
      component: DeletedUsers,
    },
  ];

  const activeTabData = tabs.find(tab => tab.id === activeTab);
  const ActiveComponent = activeTabData?.component;

  return (
    <Layout>
      <div className="trash">
        <div className="trash__header">
          <div className="trash__title">
            <Trash2 size={24} />
            <h1 className="trash__title-text">Thùng rác</h1>
          </div>
          <p className="trash__description">
            Quản lý và khôi phục các dữ liệu đã bị xóa
          </p>
        </div>

        <TrashTabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        <div className="trash-content">
          {ActiveComponent && <ActiveComponent />}
        </div>
      </div>
    </Layout>
  );
};

export default Trash;
